import { useContentfulContentTypeEntry } from '@order/Contentful';
import { useLocalizationContext } from '@order/Localization';

/**
 * Returns contentful data from 'Account Deletion'.
 * Falls back to localized strings.
 * @see: (@link: https://app.contentful.com/spaces/wme4s8lvzccr/content_types/accountSweetpassPage)
 */
export const useAccountDeletionContentfulData = () => {
  const { t } = useLocalizationContext();

  const { data: contentfulData, fetching: isLoadingContentfulData } =
    useContentfulContentTypeEntry<AccountDeletionContentfulData>({
      contentType: ACCOUNT_DELETION_CONTENTFUL_ID,
      include: 2,
    });

  return {
    isLoadingContentfulData,
    body: contentfulData?.fields?.step2 ?? t('account.delete.step2'),
  };
};

// ─── Constants ────────────────────────────────────────────────────

const ACCOUNT_DELETION_CONTENTFUL_ID = 'accountAccountDeletion';

// ─── Types ────────────────────────────────────────────────────────

type AccountDeletionContentfulData = Readonly<{
  step2?: string;
}>;
